// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2LdG1","colMin":"styles_colMin__1csyK","colCheckbox":"styles_colCheckbox__2HP6o"};